import React from "react";
import { Card, Grid, Skeleton } from "@mantine/core";

export default function OrganizationCardSkeleton(props) {
  return (
    <Card
      padding='lg'
      style={{
        borderRadius: "12px",
      }}
      {...props}
      withBorder>
      <Grid align='center'>
        <Grid.Col span={6}>
          <div className='flex items-center'>
            <Skeleton height={60} circle />
            <div className='flex flex-col ms-4'>
              <Skeleton height={24} mb={4} width={130} radius='xl' />
              <Skeleton height={17} mt={4} width={150} radius='xl' />
            </div>
          </div>
        </Grid.Col>
        <Grid.Col span={4}>
          <div className='flex flex-col justify-center'>
            <div className='flex items-center text-primary'>
              <Skeleton height={18} mt={0} mx={4} width={100} radius='xl' />
            </div>
            <div className='flex items-center mt-[10px] text-primary'>
              <Skeleton height={18} mt={0} mx={4} width={100} radius='xl' />
            </div>
          </div>
        </Grid.Col>
        <Grid.Col span={2}>
          <div className='flex'>
            <Skeleton height={32} circle />
            <Skeleton height={32} circle className='ms-[7px]' />
          </div>
        </Grid.Col>
      </Grid>
    </Card>
  );
}
